import { render, staticRenderFns } from "./AdPositionList.vue?vue&type=template&id=3ade7006&scoped=true&"
import script from "./AdPositionList.vue?vue&type=script&lang=js&"
export * from "./AdPositionList.vue?vue&type=script&lang=js&"
import style0 from "./AdPositionList.vue?vue&type=style&index=0&id=3ade7006&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade7006",
  null
  
)

export default component.exports